export default __webpack_public_path__ + "static/media/carmodels.6555b319.jpg";